import _FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import React from 'react';
import classnames from 'classnames';
import Image from 'swag-client-common/components/ui/image';
import Radio from 'swag-client-common/components/ui/radio-button';
import classes from './box-card-item.scss';
export const BoxCardItemComponent = ({
  boxTypeItem,
  shouldShowSuperSpeedLabel,
  selectedType,
  originalBoxType,
  onBoxTypeChange,
  className = ''
}) => {
  const {
    img,
    name,
    type,
    description,
    pricePerBox,
    assemblyFee,
    productionTimeDays,
    additionalProductionTimeText,
    requireTemplateDesign
  } = boxTypeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FormControlLabel, {
    label: "",
    classes: {
      root: classnames(classes.formControlLabelRoot, {
        [classes.formControlLabelActive]: type === selectedType
      })
    },
    control: /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.boxTypeWrapper, className)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.boxTypeInfo
    }, /*#__PURE__*/React.createElement(Image, {
      src: img,
      alt: name,
      wrapperClassName: classes.wrapperClassName
    }), /*#__PURE__*/React.createElement("h2", null, name, description ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), description) : null), pricePerBox ? /*#__PURE__*/React.createElement("p", {
      "data-text": "ItemPrice"
    }, "Price per box: $", pricePerBox) : null, assemblyFee ? /*#__PURE__*/React.createElement("p", {
      "data-text": "AssemblyFee"
    }, "Kitting fee: $", assemblyFee) : null, productionTimeDays ? /*#__PURE__*/React.createElement("p", {
      "data-text": "ProductionTime"
    }, "Box production time:", /*#__PURE__*/React.createElement("span", null, productionTimeDays, " Business days"), Boolean(additionalProductionTimeText) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "(", additionalProductionTimeText, ")"))) : null, requireTemplateDesign && /*#__PURE__*/React.createElement("p", null, "Requires template design")), /*#__PURE__*/React.createElement(Radio, {
      checked: type === selectedType,
      onClick: () => onBoxTypeChange(type),
      className: classes.radioButton
    }))
  }), shouldShowSuperSpeedLabel && /*#__PURE__*/React.createElement("div", {
    className: classes.superSpeedLabel
  }, "Super Speed"), originalBoxType === type && /*#__PURE__*/React.createElement("p", {
    className: classes.warningText
  }, "This is the box from your previous order."));
};